<template>
      <div
      class="google-map"
      ref="googleMap"
      ></div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";
import moment from "moment";
//import vconsole from 'vconsole'
//new vconsole()

export default {
  components: {
    //GoogleMapLoader,
  },

  methods: {

    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
    },


    setMapCenter(pos) {
      console.log("set map center:", pos)

      this.map.setCenter({
              lat : pos.lat,
              lng : pos.lng
      });
    },

    initializeUserMarker(pos) {
      const { Marker } = this.google.maps;


      if (this.userMarker) {
        this.userMarker.setMap(null);
      }
      this.userMarker=new Marker({
        position: pos,
        map: this.map,
      });
      this.setMapCenter(pos)
      console.log("initialize user marker:", pos)
    },

    initializeMarker() {
      const { Marker, InfoWindow } = this.google.maps;

      console.log(this.envParam)
      var activeInfoWindow= null;
      this.markers.forEach(marker => {
        var localMarker=new Marker({
          position: marker.position,
          marker: marker,
          //label: marker.label,
          map: this.map
          
          ,icon: {
            url: this.envParam.logoUrl,
            scaledSize: new this.google.maps.Size(30, 40), // scaled size
            origin: new this.google.maps.Point(0, 0), // origin
            anchor: new this.google.maps.Point(0, 0) // anchor
          }
        });

        var that=this;

        localMarker.addListener('click', function() {

        if ((activeInfoWindow)!==null) {
          activeInfoWindow.close();
          activeInfoWindow=null;
        }
          var localInfoWindow = new InfoWindow({
            content: `${marker.label}`
          })
          localInfoWindow.open(that.map, localMarker);
          activeInfoWindow=localInfoWindow;
        })
      });
    }
  },

  data() {
    return {
      userMarker: null,
      google: null,
      map: null,
      apiKey: "AIzaSyDSnn4PLwW7kMPBmXkOrcLXrA4Gd-31VRU",
      markers: [
      ]
    };
  },

  async mounted () {
    var that = this;
    var today=moment().add(-1, 'days').format('YYYY-MM-DD');
    var api= `/store?date=${today}`;


    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey,
      language: "en"
    });
    this.google = googleMapApi;
    this.initializeMap();

    this.$http.get(api)
      .then(function (response) {
        var total=response.data.total;
        console.log(response);
        response.data.single.forEach( entry => {
            if (entry.info === null) {
              entry.info = '未提供'
            }
            var marker= {
              id: entry.id,
              position: {
                lat: entry.lat,
                lng: entry.lng
              },
              label: `<br>店家名稱:${entry.name}</br>
                      <br>店家地址:${entry.address}</br>
                      <br>店家電話:${entry.phone}</br>
                      <br>本日A餐數量: ${entry.number}</br>
                      <br>累積A餐數量: ${total[entry.store_id]}</br>
                      <br>營業資訊:${entry.info}</br>`
                      
            }
            that.$data.markers.push(marker);
        })
        that.initializeMarker();
      })
  },

  computed: {
    mapConfig() {
      return {
        center: {lat: 25.0584813, lng: 121.5448748},
        zoom: 17,
        streetViewControl: false,
      };
    },

    mapCenter() {
      return this.markers[1].position;
    }
  }
};
</script>

